<template>
  <div class="download">
    <div class="row row-equal outer-container">
      <h1> {{ download_name }}</h1>
      <div class="flex xs12 dropdown-container">
        <va-card class="flex xs12">
          <div class="flex xs12 row">
            <div class="flex xs9 ">
              <multiselect :value="selectedOption" :options="options" :custom-label="onlyName" :multiple="false"
                :taggable="true" :allow-empty="false" :showLabels="false" @input="selectOption">
              </multiselect>
            </div>
            <div class="flex xs3 ">
              <va-button class="btn" @click="click_download">Download</va-button>
            </div>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Multiselect from '@vueform/multiselect'
import { httpClient } from '@/shared/services/http-client'
import { loadingService } from '@/shared/services/loading-service'

export default {
  name: "Download",
  components: {
    Multiselect,
  },
  props: {
    download_id: String,
    download_name: String,
  },
  data() {
    return {
      selectedOption: [],
      options: [],
      downloadName: '',
      multiselect_options: [],
    }
  },
  computed: {
    ...mapState({
      selectedEntity: state => state.user.selectedEntity,
      availableDocuments: state => state.download.availableDocuments,
      documentContent: state => state.download.documentContent,
    }),

  },
  watch: {
    download_id(newValue) {
      this.clearDocumentList();
      if (newValue && this.selectedEntity.id) {
        this.getDocumentList({
          entityId: this.selectedEntity.id,
          downloadId: newValue,
        });
      }
    },
    selectedEntity(newValue) {
      if (newValue && newValue.id) {
        this.getDocumentList({
          entityId: newValue.id,
          downloadId: this.download_id,
        });
      }

    },
    availableDocuments(newValue) {
      if (newValue) {
        Object.values(newValue).forEach(data => {
          this.options.push(data.file_name)
        })
      }
      if (newValue.length > 0) {
        this.selectedOption = this.options[0];
      }
      else {
        this.selectedOption = {};
        this.options = [];
      }
    },
    documentContent(newValue) {
      if (newValue !== null) {
        const byteArraryBuffer = this.base64ToArrayBuffer(this.documentContent);
        this.saveByteArray2Browser(this.selectedOption, byteArraryBuffer);
      }
    },
  },
  async created() {
    if (this.selectedEntity.id && this.download_id) {
      this.getDocumentList({
        entityId: this.selectedEntity.id,
        downloadId: this.download_id,
      });
    }
  },
  methods: {
    ...mapActions(
      {
        clearDocumentList: "download/clearDocumentList",
        getDocumentList: "download/getDocumentList",
        clearDocumentContent: "download/clearDocumentContent",
        getDocumentContent: "download/getDocumentContent",

      },
    ),
    onlyName(item) {
      return item.file_name
    },

    click_download(e) {
      this.clearDocumentContent();
      this.getDocumentContent({
        entityId: this.selectedEntity.id,
        downloadId: this.download_id,
        documentPath: this.selectedOption,
      });

    },
    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    getMIMEType(ext) {
      const MIME_Dict = {
        ".doc": "application/msword",
        ".dot": "application/msword",
        ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ".dotx": "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
        ".docm": "application/vnd.ms-word.document.macroEnabled.12",
        ".dotm": "application/vnd.ms-word.template.macroEnabled.12",
        ".xls": "application/vnd.ms-excel",
        ".xlt": "application/vnd.ms-excel",
        ".xla": "application/vnd.ms-excel",
        ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ".xltx": "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
        ".xlsm": "application/vnd.ms-excel.sheet.macroEnabled.12",
        ".xltm": "application/vnd.ms-excel.template.macroEnabled.12",
        ".xlam": "application/vnd.ms-excel.addin.macroEnabled.12",
        ".xlsb": "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
        ".ppt": "application/vnd.ms-powerpoint",
        ".pot": "application/vnd.ms-powerpoint",
        ".pps": "application/vnd.ms-powerpoint",
        ".ppa": "application/vnd.ms-powerpoint",
        ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ".potx": "application/vnd.openxmlformats-officedocument.presentationml.template",
        ".ppsx": "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
        ".ppam": "application/vnd.ms-powerpoint.addin.macroEnabled.12",
        ".pptm": "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
        ".potm": "application/vnd.ms-powerpoint.template.macroEnabled.12",
        ".ppsm": "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
        ".mdb": "application/vnd.ms-access",
      }
      if (ext in MIME_Dict) {
        return MIME_Dict[ext]
      }
      else {
        return 'text/plain'
      }

    },
    saveByteArray2Browser(reportName, byte) {
      const ext = '.' + reportName.split('.').pop();
      const MIME_type = this.getMIMEType(ext);

      const blob = new Blob([byte], { type: MIME_type });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = reportName;
      //this.pdffileName = link.href;
      link.download = fileName;
      link.click();
    },

    selectOption(option) {
      this.selectedOption = option;
    },


  },
}
</script>
<style src="@vueform/multiselect/themes/default.css">
</style>
<style scoped>
.dropdown-container {
  display: flex;
  /* flex-wrap: wrap; */
  /* border: none; */
  /* border-radius: 0.375rem; */
  /* background: white; */
}

.dropdown {
  margin: 5px;
}

.outer-container {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.row.row-equal.outer-container+.row.row-equal.outer-container {
  margin-top: 15px;
}

.row.row-equal.outer-container h1 {
  color: white;
  padding: 10px;
}

.group-title {
  float: left;
  font-weight: 600;
  padding: 0 !important;
}
</style>
